/**
 * Protege rotas disponíveis apenas no contexto de instituição
 * (conta institution ou admin com instituição selecionada).
 */

import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useInstitution } from '@/contexts/InstitutionContext'
import styles from './ProtectedRoute.module.css'

interface InstitutionOnlyRouteProps {
  children: React.ReactNode
}

export function InstitutionOnlyRoute({ children }: InstitutionOnlyRouteProps) {
  const { token, guard, isLoading } = useAuth()
  const { institutionId } = useInstitution()

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <div className={styles.spinner} />
        <p>Carregando...</p>
      </div>
    )
  }

  if (!token) {
    return <Navigate to="/login" replace />
  }

  if (guard === 'admin' && institutionId === null) {
    return <Navigate to="/home-drftadmin" replace />
  }

  if (guard !== 'institution' && guard !== 'admin') {
    return <Navigate to="/home" replace />
  }

  return <>{children}</>
}
